import { IPackageListingAppState } from "..";
import PackageApi from "../../common/package-api";
import { processPackageRequest, processPackageRequestError, receivePerformancePricing, receivePackagePricing } from "./package-listing.actions";
import { IPerformancePricing } from "../../custom/classes/production";
import { filterMap } from "../../helpers/map-helpers";

export function processPackage() {
    return (dispatch, getState: () => IPackageListingAppState) => {
        const state = getState();

        dispatch(processPackageRequest());
        var priceTypes = [];

        Array.from(state.packageListing.priceTypeQuantity.keys()).forEach(pt => {
            var quantity = state.packageListing.priceTypeQuantity.get(pt);
            var i;
            for (i = 0; i < quantity; i++) {
                priceTypes.push(pt);
            }

        });

        if (state.packageListingSettings.isFixed) {

            const superPackagesInCart = state.packageListing.subPackagesInCart;
            var regularFixedPackages = state.packageListing.cartItems;

            if (superPackagesInCart.size > 0) {
                // has super packages in cart

                regularFixedPackages = filterMap(state.packageListing.cartItems,
                    packageId => Array.from(superPackagesInCart.keys()).indexOf(packageId) < 0)

                superPackagesInCart.forEach((subPackageIds, packageId) => {
                    let subPackageZones = {};

                    subPackageIds.forEach(subPackageId => {
                        subPackageZones[subPackageId] = state.packageListing.cartItems.get(subPackageId);
                    })

                    PackageApi.processSuperPackage(packageId,
                        subPackageZones,
                        priceTypes,
                        state.packageListing.orderNotes,
                        state.packageListingSettings.configId
                    ).then(apiResult => {
                        if (apiResult.success && apiResult.redirectUrl != null) {
                            window.location = apiResult.redirectUrl;
                        } else {
                            dispatch(processPackageRequestError(apiResult.errorMessages));
                        }
                    }).catch(error => {
                        //dispatch(errorPromoCodeApply(error));
                    });
                })
            } else {
                regularFixedPackages.forEach((zoneId, packageId) => {

                    PackageApi.processFixedPackage(packageId,
                        zoneId,
                        priceTypes,
                        state.packageListing.orderNotes,
                        state.packageListingSettings.configId,
                        state.packageListing.seatingPreferences
                    ).then(apiResult => {
                        if (apiResult.success && apiResult.redirectUrl != null) {
                            window.location = apiResult.redirectUrl;
                        } else {
                            dispatch(processPackageRequestError(apiResult.errorMessages));
                        }
                    }).catch(error => {
                        //dispatch(errorPromoCodeApply(error));
                    });
                });
            }
        } else {
            let performanceZones = {};

            for (let [key, value] of state.packageListing.cartItems) {
                performanceZones[key] = value;
            }

            const packageId = state.packageListing.packageDetail.id;
            const performanceIds = Object.keys(performanceZones).join(',');

            PackageApi.flexPackageSessionVariable(packageId, performanceIds);

            // AAC26-75 - Send PWYC amounts to session before processing
            const pwycAmounts = state.packageListing.pwycAmounts;
            const pwycSettings = state.packageListing.pwycPerformanceSettings;
            let pwycPromise = Promise.resolve();

            if (pwycAmounts && pwycAmounts.size > 0 && pwycSettings) {
                const performancePriceTypeAmounts: { [perfId: number]: { [ptId: number]: number } } = {};
                pwycAmounts.forEach((amount, key) => {
                    const [perfIdStr, ptIdStr] = key.split('_');
                    const perfId = parseInt(perfIdStr);
                    const ptId = parseInt(ptIdStr);
                    if (!performancePriceTypeAmounts[perfId]) {
                        performancePriceTypeAmounts[perfId] = {};
                    }
                    performancePriceTypeAmounts[perfId][ptId] = amount;
                });

                if (Object.keys(performancePriceTypeAmounts).length > 0) {
                    pwycPromise = PackageApi.sendPwycAmounts(packageId, performancePriceTypeAmounts);
                }
            }

            return pwycPromise.then(() => {
                return PackageApi.processFlexPackage(state.packageListing.packageDetail.id, performanceZones,
                    priceTypes, state.packageListing.packageDetail.useUnseatedReservation,
                    state.packageListing.orderNotes,
                    state.packageListingSettings.configId
                );
            }).then(apiResult => {
                if (apiResult.success && apiResult.redirectUrl != null) {
                    Object.keys(localStorage)
                        .filter(key => key.startsWith('SSv2_SeatRequest'))
                        .forEach(key => localStorage.removeItem(key));
                    window.location = apiResult.redirectUrl;
                } else {
                    dispatch(processPackageRequestError(apiResult.errorMessages));
                }
            }).catch(error => {
                //dispatch(errorPromoCodeApply(error));
            });
        }

    }
}

export function getPerformancePricing(performanceId: number, facilityId: number, packageId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        //dispatch(processPackageRequest());

        return PackageApi.getPerformancePricing(performanceId, facilityId, packageId).then(apiResult => {

            dispatch(receivePerformancePricing(apiResult));
        }).catch(error => {
            //dispatch(errorPromoCodeApply(error));
        });
    }
}

export function getPackagePricing(packageId: number, facilityId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        return PackageApi.getPackagePricing(packageId, facilityId).then(apiResult => {

            dispatch(receivePackagePricing(apiResult));
        }).catch(error => {
        });
    }
}